import { Types } from '../actions/profileActions';

const defaultState = {};

const profileReducers = (state = defaultState, action) => {
  switch (action.type) {
    case Types.PROFILE_GETTING: {
      let newState = { ...state };

      if (!newState.profile) newState.profile = {};
      newState.profile.updating = true;

      return newState;
    }
    case Types.PROFILE_GET: {
      let newState = { ...state };

      if (!newState.profile) newState.profile = {};
      newState.profile.updating = false;

      // const adminPortalAdminIds = [
      //   '592272', // Lisette
      //   '251', // Emma
      //   '560053', // Zoey
      //   '583757', // Eman
      //   '583917', // Francisco
      //   '229944', // Jonathan
      //   'c705e3dc-221d-45f8-9a3b-68fbb19e6e4d', // Jessica
      //   'd6ea0730-c74e-49bb-b087-6014acc8f1ff', // Shaun
      //   '723c5b6f-062c-429b-9ed1-ddcf18034f43', // Shaun (Dev)
      //   '26222264-e0e1-70f4-ef8c-5740b1162381', // Lisette (Archer)
      //   '8642b2d4-10a1-708e-9bf0-672244e3b6de', // Eman (Archer)
      //   'a6b2c2e4-b001-70b9-e209-9453b6c571c3', // Shaun (Archer)
      //   'fcb34e6e-a454-45b2-8929-5bb9b77c4bab', // Danielle
      // ];

      newState.profile.details = {
        ...newState.profile.details, // Attributes from Cognito (may include userSub)
        id: action?.payload?.profile?.id || newState?.profile?.details?.id,
        // Cognito sub is the stable assignee / owner id (R-7702 Waiting on me).
        cognitoId:
          action?.payload?.profile?.cognitoId ||
          newState?.profile?.details?.cognitoId ||
          newState?.profile?.details?.userSub ||
          newState?.profile?.details?.sub ||
          null,
        userSub:
          newState?.profile?.details?.userSub ||
          action?.payload?.profile?.cognitoId ||
          newState?.profile?.details?.sub ||
          null,
        whiteLabelAdmin: action?.payload?.profile?.whiteLabelAdmin || false,
        cyfAdmin: action?.payload?.profile?.isAdmin || false,
        consultantAdmin: action?.payload?.profile?.consultantAdmin || false,
        ambassadorAdmin: action?.payload?.profile?.ambassadorAdmin || false,
        registrationDate: action?.payload?.profile?.registrationDate,
        credentials: newState?.profile?.details?.credentials,
        contractAdmin: action?.payload?.profile?.contractAdmin || false,
        ambassadorCreator: action?.payload?.profile?.ambassadorCreator || false,
        contractApprover: action?.payload?.profile?.contractApprover || false,
        legalAgreements: {
          userLicenseAgreementConfirmed: action.payload.userLicenseAgreementConfirmed || false,
          userPrivacyPolicyAgreementConfirmed: action.payload.userPrivacyPolicyAgreementConfirmed || false,
        },
        permissions: action?.payload?.profile?.permissions || { portal: [] },
        dateFormat: action?.payload?.profile?.dateFormat ?? newState?.profile?.details?.dateFormat ?? 'dd/MM/yyyy',
      };

      return newState;
    }

    case Types.PROFILE_SAVING: {
      let newState = { ...state };

      newState.profile.saving = action.status;

      return newState;
    }
    case Types.GENERATING_DNS_RECORDS: {
      let newState = { ...state };

      newState.profile.generatingDNSRecords = action.status;

      return newState;
    }
    case Types.PROFILE_SAVE: {
      let newState = { ...state };

      newState.profile.saving = false;
      newState.profile.details = action.payload;

      return newState;
    }
    case Types.PROFILE_ADMIN: {
      let newState = { ...state };

      if (!newState.profile) newState.profile = {};
      if (!newState.profile.details) newState.profile.details = {};

      newState.profile.details[action.payload.admin] = action.payload.status;

      if (!newState.profile.details.permissions) {
        newState.profile.details.permissions = { portal: [] };
      }
      if (!Array.isArray(newState.profile.details.permissions.portal)) {
        newState.profile.details.permissions.portal = [];
      }

      const ensurePortalPerm = (perm) => {
        if (!newState.profile.details.permissions.portal.includes(perm)) {
          newState.profile.details.permissions.portal.push(perm);
        }
      };
      const removePortalPerm = (perm) => {
        newState.profile.details.permissions.portal = newState.profile.details.permissions.portal.filter(
          (p) => p !== perm,
        );
      };

      if (action.payload.admin === 'whiteLabelAdmin') {
        if (action.payload.status) {
          newState.isWhiteLabelApp = true;
          ensurePortalPerm('WHITELABEL');
          ensurePortalPerm('VIEW_ADMIN');
        } else {
          newState.isWhiteLabelApp = false;
          removePortalPerm('WHITELABEL');
        }
      } else if (action.payload.admin === 'cyfAdmin') {
        if (action.payload.status) {
          ensurePortalPerm('VIEW_ADMIN');
          ensurePortalPerm('CYF_ADMIN');
        } else {
          removePortalPerm('VIEW_ADMIN');
          removePortalPerm('CYF_ADMIN');
        }
        newState.isWhiteLabelApp = false;
      } else {
        newState.isWhiteLabelApp = false;
      }

      return newState;
    }
    case Types.PROFILE_SETTING_DOMAIN_EMAIL: {
      let newState = { ...state };

      if (!newState.organisation.wlDomain) {
        newState.organisation.wlDomain = {};
      }

      if (action.response.message) {
        //Error while Generating DNS Records
        newState.organisation.wlDomain = {
          ...newState.organisation.wlDomain,
          emailErrorMessage: action.response.message,
        };
      } else {
        //DNS Records Generated
        newState.organisation.details = {
          ...newState.organisation.details,
          emailIdentityDomain: action.response.domainName,
        };

        newState.organisation.wlDomain = {
          ...newState.organisation.wlDomain,
          dnsRecordsEmailDomain: action.response.dnsRecords,
        };
      }

      return newState;
    }

    case Types.PROFILE_SETTING_DOMAIN_APP_STATUS: {
      let newState = { ...state };

      if (!newState.organisation.wlDomain) {
        newState.organisation.wlDomain = {};
      }

      if (action.response?.data?.executionArn) {
        //Getting Execution Arn to start step function

        newState.organisation.wlDomain.creatingDomain = action.response?.data;

        return newState;
      } else {
        // Step Function Execution was Succeeded

        const output = JSON.parse(action.response.output);

        if (output.message) {
          //Error while Generating DNS Records
          newState.organisation.wlDomain = {
            ...newState.organisation.wlDomain,
            errorMessage: output.message,
          };
        } else {
          //DNS Records Generated
          newState.organisation.details = {
            ...newState.organisation.details,
            liveDomain: output.liveDomain,
          };

          newState.organisation.wlDomain = {
            ...newState.organisation.wlDomain,
            appDomainDNSRecords: output.dnsRecords,
            errorMessageAppDomain: null,
          };
        }

        return newState;
      }
    }

    case Types.CREATE_WL_DOMAIN_STATUS: {
      let newState = { ...state };

      newState.organisation.wlDomain.creatingDomain = {
        ...newState.organisation.wlDomain.creatingDomain,
        status: action.payload.data.status,
        stopDate: action.payload.data.stopDate,
      };

      return newState;
    }

    case Types.GET_SHORT_CODE: {
      let newState = { ...state };

      newState.promoter = {};

      if (!action.response) {
        delete newState.promoter.referralCode;
      }

      newState.promoter = {
        referralCode: action?.response?.referralCode,
      };

      return newState;
    }

    case Types.UPDATE_ORGANISATION: {
      let newState = { ...state };
      const stripeAccountId = action.payload;

      console.log('stripeAccountId', stripeAccountId);

      const orgDetails = state.organisation.details;

      newState.organisation.details = { ...orgDetails, stripeAccountId: stripeAccountId };

      return newState;
    }

    default:
      return state;
  }
};

export default profileReducers;
